"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let InvoiceBrowser = class InvoiceBrowser extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
    }
    invoiceTypeBadgeClass(...args) {
        const [row] = args;
        const cc = this.$config.invoice.types.colorCodes[row.invoice_type];
        return `bg-${cc.bg} text-${cc.text}`;
    }
    dataLoaded(...args) {
        this.actions.search.trigger(this);
    }
    multiselect;
    onMultiselect(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("multiselect");
    }
    kind;
    onKind(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("kind");
    }
    company_id;
    onCompany_id(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("company_id");
    }
    client_id;
    onClient_id(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("client_id");
    }
    invoice_number;
    onInvoice_number(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("invoice_number");
    }
    invoice_date;
    onInvoice_date(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("invoice_date");
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    formId;
    async $$load_formId() {
        return this.$fn.randomElementId();
    }
    selectedItems;
    invoices;
    selectedInvoices;
    filters;
    async $$load_filters() {
        return {
            date_from: this.invoice_date,
            date_to: null,
            kind: this.kind ? [this.kind] : [],
            company_id: this.company_id,
            client_id: this.client_id,
            unpaid: true
        };
    }
    invoiceKinds;
    ux;
    b_7315092382398562_modalBindings;
    b_5731695935601903_dataSource;
    b_3054425420812800_dataSource;
    b_2070266589801014_editable;
    b_2070266589801014_columnDefaults;
    b_2070266589801014_columns;
    async $$load_b_2070266589801014_columns() {
        return [{
                field: "invoice_kind",
                name: this.$fn.pgettext("InvoicesView", "Kind"),
                formatter: {
                    name: "mapvalue",
                    mapping: {
                        incoming: this.$fn.pgettext("InvoiceKind", "In"),
                        outgoing: this.$fn.pgettext("InvoiceKind", "Out"),
                    },
                },
            },
            {
                field: "invoice_number",
                name: this.$fn.pgettext("InvoicesView", "Invoice nr"),
                formatter: [{
                        name: "chain",
                        formatters: [{
                                name: "template",
                                engine: "hb",
                                format: "#!{{ $value }} {{~#if reference_number }} ({{ reference_number }}){{~/if }}",
                            },
                            {
                                name: "cellclass",
                                value: (row) => ({
                                    'font-weight-bold': true,
                                    'bg-yellow-200': !row.locked,
                                    'bg-yellow-500 text-yellow-800': row.is_corrected,
                                    'bg-red-300 text-red-800': row.is_reversed,
                                }),
                            },
                        ],
                    },
                ],
            },
            {
                field: "invoice_type",
                name: this.$fn.pgettext("InvoicesView", "Type"),
                formatter: {
                    name: "chain",
                    formatters: [{
                            name: "gettext",
                            context: "InvoiceType",
                            conversion: "StartCase",
                            filterInput: true,
                        },
                        {
                            name: "badge",
                            dot: true,
                            pill: true,
                            badgeClass: this.invoiceTypeBadgeClass,
                        },
                    ],
                },
            },
            {
                field: "invoice_status",
                name: this.$fn.pgettext("InvoicesView", "Status"),
                formatter: {
                    name: "gettext",
                    context: "Status",
                    conversion: "StartCase",
                    filterInput: true,
                },
            },
            {
                field: "invoice_date",
                name: this.$fn.pgettext("InvoicesView", "Date"),
            },
            {
                field: "fulfillment_date",
                name: this.$fn.pgettext("InvoicesView", "Fulfillment date"),
                type: "date",
            },
            {
                field: "due_date",
                name: this.$fn.pgettext("InvoicesView", "Due date"),
                type: "date",
            },
            {
                field: "register_entry",
                name: this.$fn.pgettext("InvoicesView", "Register entry"),
                formatter: {
                    name: "getvalue",
                    field: "entry_number",
                    source: "value",
                },
            },
            {
                field: "client_name",
                name: this.$fn.pgettext("InvoicesView", "Client"),
                formatter: {
                    name: "routeLink",
                    to: "company",
                    navigateOnIconClick: true,
                    params: {
                        id: "client_id",
                    },
                },
            },
            {
                field: "description",
                name: this.$fn.pgettext("InvoicesView", "Description"),
            },
            {
                field: "net_amount",
                name: this.$fn.pgettext("InvoicesView", "Net"),
                type: "number",
                formatter: "number",
            },
            {
                field: "total_amount",
                name: this.$fn.pgettext("InvoicesView", "Amount"),
                type: "number",
                formatter: "number",
            },
            {
                field: "outstanding_amounts",
                name: this.$fn.pgettext("Invoices", "Outstanding Amounts"),
                type: "number",
                formatter: {
                    name: "chain",
                    formatters: [{
                            name: "number",
                        },
                        {
                            name: "cellclass",
                            value: (row) => {
                                if (row.flags && row.flags.no_payment_required) {
                                    return 'font-weight-bold text-decoration-line-through';
                                }
                                if (row.outstanding_amounts != null && row.outstanding_amounts > 0) {
                                    return 'font-weight-bold text-red-500';
                                }
                                if (row.outstanding_amounts != null && row.outstanding_amounts < 0) {
                                    return 'font-weight-bold text-blue-500';
                                }
                                if (row.outstanding_amounts == 0) {
                                    return 'font-weight-bold text-green-500';
                                }
                            },
                        },
                    ],
                },
            },
            {
                field: "paid_amount",
                name: this.$fn.pgettext("InvoicesView", "Paid"),
                type: "number",
                formatter: {
                    name: "chain",
                    formatters: [{
                            name: "number",
                        },
                        {
                            name: "cellclass",
                            value: (row) => {
                                if (row.flags && row.flags.no_payment_required) {
                                    return 'font-weight-bold text-decoration-line-through';
                                }
                            },
                        },
                    ],
                },
            },
            {
                field: "max_payment_date",
                name: this.$fn.pgettext("PaymentBrowserView", "Date of last settlement"),
                type: "date",
            },
            {
                field: "currency",
                name: this.$fn.pgettext("InvoicesView", "Currency"),
            },
            {
                field: "tags",
                name: this.$fn.pgettext("InvoicesView", "Tags"),
            },
            {
                field: "rentals",
                name: this.$fn.pgettext("InvoicesView", "Rentals"),
                formatter: {
                    name: "chain",
                    mode: "mapReduce",
                    separator: ", ",
                    formatterContext: "value",
                    formatters: [{
                            name: "getvalue",
                            opts: {
                                field: "name",
                                source: "value",
                            },
                        },
                        {
                            name: "routeLink",
                            to: "rental",
                            navigateOnIconClick: true,
                            params: {
                                id: "id",
                            },
                        },
                    ],
                },
            },
            {
                field: "contracts",
                name: this.$fn.pgettext("InvoicesView", "Contracts"),
                formatter: {
                    name: "chain",
                    mode: "mapReduce",
                    separator: ", ",
                    formatterContext: "value",
                    formatters: [{
                            name: "getvalue",
                            opts: {
                                field: "contract_number",
                                source: "value",
                            },
                        },
                        {
                            name: "routeLink",
                            to: "contract",
                            navigateOnIconClick: true,
                            params: {
                                id: "id",
                            },
                        },
                    ],
                },
            },
            {
                field: "created_at",
                name: this.$fn.pgettext("BrowserColumn", "Create time"),
                formatter: "datetime",
            },
        ];
    }
    dataMembers = ['formId', 'selectedItems', 'invoices', 'selectedInvoices', 'filters', 'invoiceKinds', 'ux', 'b_7315092382398562_modalBindings', 'b_5731695935601903_dataSource', 'b_3054425420812800_dataSource', 'b_2070266589801014_editable', 'b_2070266589801014_columnDefaults', 'b_2070266589801014_columns'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                formId: null,
                selectedItems: null,
                invoices: [],
                selectedInvoices: [],
                filters: null,
                invoiceKinds: [{
                        id: "incoming",
                        text: this.$fn.pgettext("InvoiceKind", "Incoming"),
                    },
                    {
                        id: "outgoing",
                        text: this.$fn.pgettext("InvoiceKind", "Outgoing"),
                    },
                ],
                ux: null,
                b_7315092382398562_modalBindings: {
                    emptyFooter: true,
                    size: "full-screen",
                },
                b_5731695935601903_dataSource: {
                    name: "suggest_company",
                    parameters: {
                        role: "own",
                    },
                },
                b_3054425420812800_dataSource: {
                    name: "suggest_company",
                    parameters: {
                        role: "partner",
                    },
                },
                b_2070266589801014_editable: false,
                b_2070266589801014_columnDefaults: {
                    sortable: true,
                    filterable: true,
                    resizable: true,
                },
                b_2070266589801014_columns: null,
            },
        };
    }
    get document() {
        if (this.loaded) {
            return {
                title: this.$fn.pgettext("InvoiceBrowser", "Browse Invoices"),
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_3362_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async evh_2248226175642056_close(event, scope) {
        return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
    }
    async act_5534025912102772_setData_3368_getActionArgs($event) {
        return {
            path: "invoices",
            value: $event.data.response.data,
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async act_5534025912102772_cache_3370_getActionArgs($event) {
        return {
            path: "filters",
        };
    }
    async act_5534025912102772_request_3366_getActionArgs($event) {
        return {
            operation: "list_invoice",
            parameters: _.pickBy(this.filters, v => v || !_.isEmpty(v)),
        };
    }
    async evh_5534025912102772_submit(event, scope) {
        return await this.actions.evh_5534025912102772_submit.executeFromDOM(this, event, scope);
    }
    async act_8595055453218999_closeComponent_3372_getActionArgs($event) {
        return {
            result: {
                ok: true,
                value: this.multiselect ? this.selectedItems : this.selectedItems[0],
            },
        };
    }
    async evh_8595055453218999_click(event, scope) {
        return await this.actions.evh_8595055453218999_click.executeFromDOM(this, event, scope);
    }
    async act_2070266589801014_setData_3374_getActionArgs($event) {
        return {
            path: "selectedItems",
            value: $event.data.sender.getSelectedItems(),
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async evh_2070266589801014_selectedRowsChanged(event, scope) {
        return await this.actions.evh_2070266589801014_selectedRowsChanged.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_3362 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_3362_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_3361 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_3362,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_3361],
        });
        const act_2248226175642056_closeComponent_3364 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_2248226175642056_close_3363 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_closeComponent_3364,
            event: "close",
            displayName: "closeComponent",
        });
        const evh_2248226175642056_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_close_3363],
        });
        const act_5534025912102772_setData_3368 = new core_1.actions.SetDataAction({
            actionArgs: this.act_5534025912102772_setData_3368_getActionArgs,
            events: [],
        });
        const evh_5534025912102772_success_3367 = new core_1.actions.EventHandlerImpl({
            action: act_5534025912102772_setData_3368,
            event: "success",
            displayName: "setData",
        });
        const act_5534025912102772_cache_3370 = new core_1.actions.CacheAction({
            actionArgs: this.act_5534025912102772_cache_3370_getActionArgs,
            events: [],
        });
        const evh_5534025912102772_success_3369 = new core_1.actions.EventHandlerImpl({
            action: act_5534025912102772_cache_3370,
            event: "success",
            displayName: "cache",
        });
        const act_5534025912102772_request_3366 = new core_1.actions.RequestAction({
            actionArgs: this.act_5534025912102772_request_3366_getActionArgs,
            displayName: "search",
            events: [evh_5534025912102772_success_3367, evh_5534025912102772_success_3369],
        });
        const evh_5534025912102772_submit_3365 = new core_1.actions.EventHandlerImpl({
            action: act_5534025912102772_request_3366,
            event: "submit",
            displayName: "search",
        });
        const evh_5534025912102772_submit = new core_1.actions.EventHandlerGroup({
            handlers: [evh_5534025912102772_submit_3365],
        });
        const act_8595055453218999_closeComponent_3372 = new core_1.actions.CloseComponentAction({
            actionArgs: this.act_8595055453218999_closeComponent_3372_getActionArgs,
            events: [],
        });
        const evh_8595055453218999_click_3371 = new core_1.actions.EventHandlerImpl({
            action: act_8595055453218999_closeComponent_3372,
            event: "click",
            displayName: "closeComponent",
        });
        const evh_8595055453218999_click = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8595055453218999_click_3371],
        });
        const act_2070266589801014_setData_3374 = new core_1.actions.SetDataAction({
            actionArgs: this.act_2070266589801014_setData_3374_getActionArgs,
            events: [],
        });
        const evh_2070266589801014_selectedRowsChanged_3373 = new core_1.actions.EventHandlerImpl({
            action: act_2070266589801014_setData_3374,
            event: "selectedRowsChanged",
            displayName: "setData",
        });
        const evh_2070266589801014_selectedRowsChanged = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2070266589801014_selectedRowsChanged_3373],
        });
        return {
            act_7315092382398562_closeModal_3362,
            evh_7315092382398562_close_3361,
            evh_7315092382398562_close,
            act_2248226175642056_closeComponent_3364,
            evh_2248226175642056_close_3363,
            evh_2248226175642056_close,
            act_5534025912102772_setData_3368,
            evh_5534025912102772_success_3367,
            act_5534025912102772_cache_3370,
            evh_5534025912102772_success_3369,
            act_5534025912102772_request_3366,
            evh_5534025912102772_submit_3365,
            evh_5534025912102772_submit,
            act_8595055453218999_closeComponent_3372,
            evh_8595055453218999_click_3371,
            evh_8595055453218999_click,
            act_2070266589801014_setData_3374,
            evh_2070266589801014_selectedRowsChanged_3373,
            evh_2070266589801014_selectedRowsChanged,
            search: act_5534025912102772_request_3366,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Boolean,
    }),
    __metadata("design:type", Boolean)
], InvoiceBrowser.prototype, "multiselect", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('multiselect'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], InvoiceBrowser.prototype, "onMultiselect", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
    }),
    __metadata("design:type", String)
], InvoiceBrowser.prototype, "kind", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('kind'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], InvoiceBrowser.prototype, "onKind", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
    }),
    __metadata("design:type", String)
], InvoiceBrowser.prototype, "company_id", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('company_id'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], InvoiceBrowser.prototype, "onCompany_id", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
    }),
    __metadata("design:type", String)
], InvoiceBrowser.prototype, "client_id", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('client_id'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], InvoiceBrowser.prototype, "onClient_id", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
    }),
    __metadata("design:type", String)
], InvoiceBrowser.prototype, "invoice_number", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('invoice_number'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], InvoiceBrowser.prototype, "onInvoice_number", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({}),
    __metadata("design:type", typeof (_a = typeof date !== "undefined" && date) === "function" ? _a : Object)
], InvoiceBrowser.prototype, "invoice_date", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('invoice_date'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], InvoiceBrowser.prototype, "onInvoice_date", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "full-screen",
    }),
    __metadata("design:type", String)
], InvoiceBrowser.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], InvoiceBrowser.prototype, "onSize", null);
InvoiceBrowser = __decorate([
    (0, vue_property_decorator_1.Component)()
], InvoiceBrowser);
exports.default = InvoiceBrowser;
vue_property_decorator_1.Vue.component("InvoiceBrowser", InvoiceBrowser);
